<template>
  <q-btn-dropdown
    v-ripple="false"
    :class="{'dense-button': dense}"
    :color="color"
    :dropdown-icon="dropdownIcon"
    :icon="icon"
    :icon-right="iconRight"
    :label="label"
    :padding="padding"
    :text-color="textColor"
    unelevated
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @click="$emit('click', $event)"
  >
    <slot/>
    <slot
      slot="label"
      name="label"
    />
  </q-btn-dropdown>
</template>

<script>
export default {
  name: 'AppButtonDropdown',
  props: {
    label: {
      type: String,
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    iconRight: {
      type: String,
      default: undefined,
    },
    dropdownIcon: {
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      default: 'primary',
    },
    textColor: {
      type: String,
      default: undefined,
    },
    padding: {
      type: String,
      default: '14px 22px',
    },
  },
};
</script>

<style lang="scss" scoped>
.dense-button {
  ::v-deep .q-btn__content span {
    padding: 0 4px !important;
  }

  ::v-deep .q-btn__wrapper {
    padding: 6px 2px !important;
  }
}

.q-btn {
  text-transform: none !important;
}

::v-deep .q-btn {
  &--outline {
    ::v-deep .q-btn__content span {
      font-weight: 500;
    }
  }

  text-transform: none !important;
  font-size: 17px;
  font-weight: 700;

  &.disabled {
    opacity: 1 !important;
    background-color: #CCDBEA !important;
  }

  ::v-deep .q-btn__content span {
    padding: 0 30px;
  }

}
</style>
